import { render, staticRenderFns } from "./EditAdvertiser.vue?vue&type=template&id=26b12ed8&scoped=true&"
import script from "./EditAdvertiser.vue?vue&type=script&lang=js&"
export * from "./EditAdvertiser.vue?vue&type=script&lang=js&"
import style0 from "./EditAdvertiser.vue?vue&type=style&index=0&id=26b12ed8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b12ed8",
  null
  
)

export default component.exports